import { CanActivateFn } from '@angular/router';
import { createFeatureAccessGuard } from '../permissions/module-access.guard';

export const socialMediaAccessGuard: CanActivateFn = createFeatureAccessGuard('socialmedia');
